import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// BootstrapVue
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import APICONFIG from './sfs-sdk-config'
import * as _ from "lodash"

Vue.use(BootstrapVue, BootstrapVueIcons)
Object.defineProperty(Vue.prototype, '_', { value: _ })

// Import Main styles for this application
import './assets/scss/style.scss';

APICONFIG.initConfig();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')